// components/DataPreviewTable.jsx
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography
} from '@mui/material';

function DataPreviewTable({ data, headers, rawData }) {
  if (!data || data.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography color="text.secondary">
          Tidak ada data untuk ditampilkan
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom>
        <strong>Preview Data ({data.length} baris × {headers.length} kolom)</strong>
      </Typography>
      
      <TableContainer 
        component={Paper} 
        variant="outlined"
        sx={{ 
          maxHeight: 400,
          overflow: 'auto'
        }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell 
                  key={index}
                  sx={{ 
                    fontWeight: 'bold',
                    backgroundColor: 'primary.light',
                    color: 'primary.contrastText'
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.slice(0, 50).map((row, rowIndex) => (
              <TableRow 
                key={rowIndex}
                sx={{ 
                  '&:nth-of-type(odd)': { backgroundColor: 'action.hover' }
                }}
              >
                {headers.map((header, colIndex) => (
                  <TableCell key={`${rowIndex}-${colIndex}`}>
                    {row[header] || ''}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {data.length > 50 && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          Menampilkan 50 baris pertama dari {data.length} baris
        </Typography>
      )}

      <Box sx={{ mt: 3 }}>
        <Typography variant="body2" color="text.secondary">
          <strong>Tips:</strong> Data akan diimport dengan struktur kolom seperti di atas.
        </Typography>
      </Box>
    </Box>
  );
}

export default DataPreviewTable;